import React, { Component } from "react";
import "../articles/articles.css";
import "./homePage.css";
const PresidentItem = (props) => {
  return (
    <div className={`pastPresidentItem`}>
      <div className={`pastPresidentItemBody`}>
        <div className="pastPresidentItemImageBox">
          <img
            className="pastPresidentItemImage"
            src={props.data.image}
            alt=""
            style={{
              objectPosition: props.data.imagePos || "",
              transform: `${
                props.data.imageScale
                  ? `scale(${props.data.imageScale})`
                  : "none"
              }`,
              transformOrigin: props.data.imageScalePos || ""
            }}
          />
        </div>
        <div className="pastPresidentItemBottom">
          <div className="pastPresidentItemLogoImageBox">
            <div className="pastPresidentItemLogoImage">
              <img
                className="pastPresidentItemLogoImageBody"
                src={props.data.imageLogo}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="pastPresidentItemInfo">
        <span className="pastPresidentItemYear">{props.data.year}</span>
        <span className="pastPresidentItemYear">{props.data.name}</span>
      </div>
    </div>
  );
};

export default PresidentItem;
